// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oN5O","content":"styles_content__1nOfJ","tableWrap":"styles_tableWrap__EHE7h"};